import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { projectConstants } from '../../../shared/constants/project-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountUserService } from 'src/app/services/account-user.service';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-payment-stat-list',
  templateUrl: './payment-stat-list.component.html',
  styleUrls: ['./payment-stat-list.component.css']
})
export class PaymentStatListComponent implements OnInit {
  tableFilters = '';
  displayedColumns = ['uid', 'accountname', 'mobile', 'email', 'booking', 'details'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  screenHeight;
  screenWidth;
  small_device_display = false;
  user: any;
  type: any;
  statType: string;
  DateCatogory: string;
  StatDateType: string;
  account: string;
  apptData;
  appt_details_sp: any;
  appt: any;
  accEncUid;
  businessName;
  subDomain;
  domain;
  email;
  accId: any;
  stat_type: any;
  stat_datetype: any;
  includeTest: any;
  start_date: any;
  applied_filter: any;
  end_date: any;
  date_category: any;
  showappt_data: true;
  showbillPayment_data: true;
  showdonationPayment_data: true;
  showprePayment_data: true;
  showcheckin_data: true;
  showorder_data: true;
  showdonation_for_data: true;
  showpayment_for_data: true;
  tokenData;
  orderData;
  billPaymentData;
  donationPaymentData;
  prePaymentData;
  donationData;
  paymentData;
  allData;
  mode_selection;
  value;
  isTeleservice: string;
  teleservice_data: boolean;
  showall_data: boolean;
  constructor(
    private accountuserService: AccountUserService,
    private route: ActivatedRoute,
    private router: Router,
    private activatedRoute: ActivatedRoute,) {
  }
  ngOnInit() {
    this.stat_type = this.route.snapshot.params['statType'];
    this.stat_datetype = this.route.snapshot.params['StatDateType'];
    this.includeTest = this.route.snapshot.params['accountvalue'];
    this.date_category = this.route.snapshot.params['dayvalue'];
    this.start_date = this.route.snapshot.params['startvalue'];
    this.end_date = this.route.snapshot.params['endvalue'];
    this.applied_filter = this.route.snapshot.params['filter'];
    this.teleservice_data = this.route.snapshot.params['teleservice'];
    this.mode_selection = this.route.snapshot.params['mode'];
    this.isTeleservice = this.teleservice_data.toString();
    if (this.stat_type === 'CHECKIN') {
      this.GoSPlistToken();
      this.showcheckin_data = true;
    }
    else if (this.stat_type === 'DONATION') {
      this.GoSPlistDonation();
      this.showdonation_for_data = true;
    }
    else if (this.stat_type === 'APPT') {
      this.GoSPlistAppt();
      this.showappt_data = true;
     
    }
    else if (this.stat_type === 'ORDER') {
      this.GoSPlistOrder();
      this.showorder_data = true;
    }
    else if (this.stat_type === 'BILL_PAYMENT') {
      this.GoSPlistBillPayment();
      this.showbillPayment_data = true;
    }
    else if (this.stat_type === 'DONATION_PAYMENT') {
      this.GoSPlistDonationPayment();
      this.showdonationPayment_data = true;
    }
    else if (this.stat_type === 'PREPAYMENT') {
      this.GoSPlistprePayment();
      this.showprePayment_data = true;
    }
    else if (this.stat_type === 'ALL') {
      this.GoSPlistAll();
      this.showall_data = true;
    }
    else {
      this.GoSPlistPayment();
      this.showpayment_for_data = true;
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  GoSPlistprePayment() {
    this.statType = 'PREPAYMENT';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.prePaymentData = data;
      }
    )
  }
  GoSPlistDonationPayment() {
    this.statType = 'DONATION_PAYMENT';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.donationPaymentData = data;
      }
    )
  }
  GoSPlistBillPayment() {
    this.statType = 'BILL_PAYMENT';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.billPaymentData = data;
      }
    )
  }
  GoSPlistOrder() {
    this.statType = 'ORDER';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.orderData = data;
      }
    )
  }
  
  GoSPlistToken() {
    this.statType = 'CHECKIN';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category  + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category  + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.tokenData = data;
      }
    )
  }
  GoSPlistAppt() {
    this.statType = 'APPT';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.apptData = data;
      }
    )
  }
  GoSPlistAll(){
    this.statType = 'ALL';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      } else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
        }
        else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
    }
    else {
      if (this.isTeleservice === 'true') {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'tele_service=' + this.teleservice_data + '&' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }
      }
      else {
        if (this.mode_selection === 'default') {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + this.applied_filter;
        } else {
          newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'booking_mode=' + this.mode_selection + '&' + this.applied_filter;
        }

      }
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.allData = data;
      }
    ) 
  }
  GoSPlistDonation() {
    this.statType = 'DONATION';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
    } else {
      newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + this.applied_filter;
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.donationData = data;
      }
    )
  }
  GoSPlistPayment() {
    this.statType = 'PREPAYMENT';
    this.StatDateType = 'BOOKING_ON';
    let newlyfilterParam = '';
    if (this.date_category === 'DATE_RANGE') {
      newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payment/sp?' + 'date-le=' + this.end_date + '&date-ge=' + this.start_date + '&' + this.applied_filter;
    } else {
      newlyfilterParam = this.statType + '/date' + '/' + this.date_category + '/withTest' + '/' + this.includeTest + '/payments/sp?' + this.applied_filter;
    }
    this.accountuserService.getspStat(newlyfilterParam).subscribe(
      (data) => {
        this.paymentData = data;
      }
    )
  }

  show_sp_details() {
    this.router.navigate(['../../accounts', 'details'], { queryParams: { accountId: 'stat' }, relativeTo: this.activatedRoute });
  }
  goBacktoList() {
    this.router.navigate(['../../paymentStat'], { queryParams: { dateCatogory: this.date_category, isIncludeTest: this.includeTest, startDate: this.start_date, endDate: this.end_date, filterApplied: this.applied_filter, }, relativeTo: this.activatedRoute });
  }

}